import { ContractStage } from "../../workbench/types/WbTypes";

export const contractStages: {
    name: ContractStage;
    color: string;
    halo: string;
    description: string;
    items: string[];
}[] = [
    {
        name: "Intake",
        color: "#2563eb",
        halo: "rgba(37, 99, 235, 0.17)",
        description: "We are collecting submission and initial risk details.",
        items: [
            "Draft slip or submission pack",
            "Proposed cover, limits and contract period",
            "Exposure and loss experience data, where applicable",
        ],
    },
    {
        name: "In Discussion",
        color: "#f59e0b",
        halo: "rgba(245, 158, 11, 0.16)",
        description: "We are negotiating terms and resolving open questions.",
        items: [
            "Final wording and outstanding subjectivities",
            "Premium and brokerage terms",
            "Reinsurer line/share confirmations",
        ],
    },
    {
        name: "Agreed",
        color: "#0d9488",
        halo: "rgba(13, 148, 136, 0.17)",
        description: "Terms are agreed; binding documents are being prepared.",
        items: [
            "Signed slip or written line confirmation",
            "Final contract wording or evidence of cover",
            "Confirmed inception date and signed shares",
        ],
    },
    {
        name: "Active",
        color: "#16a34a",
        halo: "rgba(22, 163, 74, 0.17)",
        description: "Cover is in force; accounting and reporting continue.",
        items: [
            "Final contract documentation",
            "Premium/accounting confirmation",
            "Required bordereaux or claims reporting, where applicable",
        ],
    },
    {
        name: "Renewal",
        color: "#7c3aed",
        halo: "rgba(124, 58, 237, 0.17)",
        description: "We are reviewing experience and next-period terms.",
        items: [
            "Updated exposure and loss experience",
            "Renewal terms and pricing",
            "Renewal line/share confirmations",
        ],
    },
    {
        name: "Closed",
        color: "#64748b",
        halo: "rgba(100, 116, 139, 0.18)",
        description: "Placement is closed; final records are being archived.",
        items: [
            "Final premium adjustment or reconciliation",
            "Open-claims/run-off responsibility confirmed",
            "Final documents and closure record archived",
        ],
    },
];
